<div class="flex items-center justify-end mb-4">
  <p-selectbutton
    [options]="viewModeOptions"
    [ngModel]="viewMode()"
    (onChange)="onViewModeChange($event.value)"
    optionValue="value"
    [allowEmpty]="false"
  >
    <ng-template #item let-item>
      <i [class]="item.icon"></i>
    </ng-template>
  </p-selectbutton>
</div>

@if (loading()) {
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <p-skeleton height="9rem" borderRadius="0.5rem"></p-skeleton>
    <p-skeleton height="9rem" borderRadius="0.5rem"></p-skeleton>
    <p-skeleton height="9rem" borderRadius="0.5rem"></p-skeleton>
  </div>
} @else if (items().length === 0) {
  <ng-content select="[emptyState]"></ng-content>
} @else {
  @if (viewMode() === 'grid') {
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      @for (item of items(); track keyOf(item, $index)) {
        <ng-container *ngTemplateOutlet="cardTemplate(); context: { $implicit: item }"></ng-container>
      }
    </div>
  } @else {
    <p-card class="paginated-entity-list-list block">
      <div class="flex flex-col divide-y divide-surface-200 dark:divide-surface-700">
        @for (item of items(); track keyOf(item, $index); let first = $first; let last = $last) {
          <ng-container *ngTemplateOutlet="rowTemplate(); context: { $implicit: item, first: first, last: last }"></ng-container>
        }
      </div>
    </p-card>
  }

  @if (totalRecords() > rows()) {
    <p-paginator
      styleClass="mt-4"
      (onPageChange)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first}-{last} / {totalRecords}"
      [pageLinkSize]="3"
      [first]="first()"
      [rows]="rows()"
      [totalRecords]="totalRecords()"
      [rowsPerPageOptions]="rowsPerPageOptions()"
    />
  }
}
